export default __webpack_public_path__ + "src/images/btn_left-e33459.png";